import { createApp } from 'vue'
import App from '@/App.vue'
import { createPinia } from 'pinia'
import { mountWhenAvailable } from './mount';
import services from './services';
import { useL10NStore} from '@/stores/i18n.store';

import '@/styles/foundation.scss'
import { Tooltips } from '@printos/agnostic-tooltips';

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);

let times = {
  start: Date.now(),
  bootstrap: 0,
  i18n: 0,
  mountAvailable: 0,
  mounted: 0,
  ready: 0,
};

window.addEventListener('pros-mounted', event => {
  times.mounted = Date.now();
});

document.addEventListener('posb-ready', event => {
  times.ready = Date.now();
  // console.log('Bootstrap', times.bootstrap - times.start);
  // console.log('i18n', times.i18n - times.bootstrap);
  // console.log('Mounted', times.mounted - times.mountAvailable);
  // console.log('Ready', times.ready - times.mounted);
  console.log('Total Load Time', times.ready - times.start);
});


import { publishGlobalApi } from './api';
publishGlobalApi(services);

mountWhenAvailable().then(mountPoint => {
  initHeader().then(bootstrapped => {
    if (bootstrapped) {
      mountAsync(mountPoint);
    }
  });
});

async function initHeader() {
  let bootstrapped = await services.session.bootstrapSessionAsync(app);
  if (bootstrapped) {
    app.use(useL10NStore().i18n);
    times.bootstrap = Date.now();
    times.i18n = Date.now();

    let tooltips = new Tooltips();
    tooltips.addObserver();
  }

  return bootstrapped;
}

async function mountAsync(mountPoint) {
  times.mountAvailable = Date.now();
  await preInitAsync();
  app.mount(mountPoint);
  if (!services.session.isSuppress()) {
    asyncInit();
  }
}

async function preInitAsync() {
  await services.session.initSessionAsync();
  await services.market.preInitAsync();
}

function asyncInit() {
  services.map.initAsync();
  services.market.initAsync();
  if (!services.session.isOrphan()) {
    services.notifications.init();
  }

  services.consent.init();

  const headless = services.session.isHeadless() || (services.app.getCurrentAppId() === 'printbeat' && !services.session.isAuthenticated() && services.session.isAnonymousAllowed());
  if (!headless) {
    services.intercom.init();
    services.help.init();
    services.help.ensureWalkMeReady();
    services.alerts.initAsync();
  }
}
